import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/api";

export const Footer = () => (
  <footer className="bg-slate-900 text-slate-300 mt-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src={LOGO_URL} alt="logo" className="h-11 w-11 object-contain bg-white rounded-lg p-1" />
            <span className="font-display font-extrabold text-white text-lg">Les Yeux Dans L'Immo</span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
            Votre avis de valeur immobilier gratuit et instantané, spécialiste de la région
            Auvergne-Rhône-Alpes.
          </p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contact</h4>
          <a href="mailto:lesyeuxdanslimmo@gmail.com" className="text-sm text-slate-400 hover:text-white transition-colors break-all" data-testid="footer-contact-email">
            lesyeuxdanslimmo@gmail.com
          </a>
          <ul className="space-y-2 text-sm mt-4">
            <li><Link to="/" className="hover:text-white transition-colors">Accueil</Link></li>
            <li><Link to="/estimation" className="hover:text-white transition-colors">Estimer mon bien</Link></li>
            <li><Link to="/admin/login" className="hover:text-white transition-colors">Espace propriétaire</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Zone couverte</h4>
          <p className="text-sm text-slate-400 leading-relaxed">
            Lyon · Grenoble · Annecy · Chambéry · Clermont-Ferrand · Saint-Étienne · Valence ·
            Chamonix et toute la région.
          </p>
        </div>
      </div>
      <div className="border-t border-slate-800 mt-10 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-slate-500">
        <span>© {new Date().getFullYear()} Les Yeux Dans L'Immo — Avis de valeur fournis à titre indicatif.</span>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <Link to="/confidentialite" className="hover:text-white transition-colors" data-testid="footer-privacy-link">Politique de confidentialité</Link>
          <Link to="/mentions-legales" className="hover:text-white transition-colors" data-testid="footer-legal-link">Mentions légales</Link>
          <a href="mailto:lesyeuxdanslimmo@gmail.com" className="hover:text-white transition-colors">Contact</a>
        </div>
      </div>
    </div>
  </footer>
);
